import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './api-services/user.service';
import { UserInfoService } from './user.service';
import { catchError, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private isAuthenticated = false;

  constructor(private router: Router, private apiService: UserService, private userInfoService: UserInfoService) {
  }

  login() {
    this.isAuthenticated = true;
  }

  logout(): void {
    this.isAuthenticated = false;
    this.userInfoService.clear();
    this.apiService.logout().pipe(
      catchError(err => {
        // // if the backend replies 401, we’re already logged-out client-side,
        // // so just swallow it
        // if (err.status === 401) {
        //   return of(null);
        // }
        return throwError(() => err);
      })
    ).subscribe({
      complete: () => {
        this.router.navigate(['/sign-in']);
      }
    });
  }

  isLoggedIn(): boolean {
    return this.isAuthenticated;
  }

  setAuthenticate(value: boolean) {
    this.isAuthenticated = value;
  }

}
